<template>

    <v-row no-gutters>
      <v-col cols="12">
        <div class="primary--text text-left text-body-2">
          Cliente: {{ data.NombreCli }}
        </div>
      </v-col>
      <v-col cols="6">
        <v-card flat tile>
          <div class="text-left text-body-2">
            {{ data.Descrip }}
          </div>

          <div class="text-left text-body-2 ">
            Entrega: {{ data.FechaEntregaCli }}
          </div>
          <div class="text-left text-body-2">
            Cond Pago: {{ data.CondicionPago }}
          </div>
                   <div class="text-left text-body-2">
            Tipo Doc: {{ data.TipoDoc }}
          </div>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card flat tile>
 
          <div class="text-left text-body-2">
            Emisión: {{data.FechaEmision}}
          </div>
          <div class="text-left text-body-2">
            Vence: {{data.FechaVence}}
          </div>
          <div class="text-left text-body-2">
            Numero De Pedido: {{data.NumeroPedido}}
          </div>
        </v-card>
      </v-col>
    </v-row>

</template>

<script>
export default {
  props: {
    data: Object,
  },
};
</script>
